export const DateTimeHelper = {
    getCurrentDate(){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        return yyyy + '-' + mm + '-' + dd;
    },
    getCurrentTime(){
        var today = new Date();
        return (today.getHours()<10?'0':'') + today.getHours() + ":" + 
        (today.getMinutes()<10?'0':'') + today.getMinutes() + ":" + 
        (today.getSeconds()<10?'0':'') +today.getSeconds();
    },
    getCurrentDateAndTime(){
        let date = this.getCurrentDate();
        let time = this.getCurrentTime();

        return date + ' ' + time;
    }
}